import React from 'react';
import { useSelector } from 'react-redux';

import { ReturnStatus } from '../../../enums/return-status';
import RMANumberLinkContainer from '../../../components/rma-number-link';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const RMANumberColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return null;
  }

  const rmaNumber = ret.rmaNumber;
  const disabled = ret.returnStatus?.toString() === ReturnStatus.Voided.toString();

  return <RMANumberLinkContainer disabled={disabled} returnId={fulfillmentId} rmaNumber={rmaNumber} />;
};

export const RmaNumber = {
  getMessageDescriptor: () => messages.rmaNumber,
  id: 'rma-number',

  render: ({ fulfillmentId }) => {
    return <RMANumberColumn fulfillmentId={fulfillmentId} />;
  },

  unpinnable: true,
};
